import { render, staticRenderFns } from "./SketchListOld.vue?vue&type=template&id=3cb25f01"
import script from "./SketchListOld.vue?vue&type=script&lang=js"
export * from "./SketchListOld.vue?vue&type=script&lang=js"
import style0 from "./SketchListOld.vue?vue&type=style&index=0&id=3cb25f01&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports